import React, { useState, useRef, useEffect } from 'react';
import { Navbar, Nav, Container, Image } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';
import AuthService from '../../services/AuthService';
import UserSessionManager from '../../utils/UserSessionManager';

const Header = () => {
  const [showPopup, setShowPopup] = useState(false);
  const profileRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const isLoggedIn = !!localStorage.getItem('accessToken');

  const togglePopup = () => setShowPopup(!showPopup);

  const storedImage = UserSessionManager.getSession()?.userProfileImg;

  const handleSignInClick = () => {
    setShowPopup(false);
    navigate('/signin');
  };

  // Close popup when clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowPopup(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <Navbar bg="light" expand="lg" className="border-bottom px-2 py-2">
      <Container fluid>
        <Navbar.Brand href="#" className="d-flex align-items-center gap-2 p-0">
          <img src='/assets/images/logo.png' alt="logo" width="70" />
          <div className="lh-sm">
            <div className="fw-bold fs-4">Nurturix</div>
            <div className="text-muted small">Let's grow together..</div>
          </div>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="navbar-nav" />
        <Navbar.Collapse id="navbar-nav">
          <Nav className="ms-auto align-items-center gap-3">
            <Nav.Link 
              href="/" 
              className={`text-dark fw-500 ${isActive('/') ? 'active-nav-link' : ''}`}
              style={{ textDecoration: 'none', color: '#000' }}
            >
              Home
            </Nav.Link>
            <Nav.Link 
              href="/products" 
              className={`text-dark fw-500 ${isActive('/products') ? 'active-nav-link' : ''}`}
              style={{ textDecoration: 'none', color: '#000' }}
            >
              Products
            </Nav.Link>
            <Nav.Link 
              href="/about" 
              className={`text-dark fw-500 ${isActive('/about') ? 'active-nav-link' : ''}`}
              style={{ textDecoration: 'none', color: '#000' }}
            >
              About us
            </Nav.Link>
            <Nav.Link 
              href="/support" 
              className={`text-dark fw-500 ${isActive('/support') ? 'active-nav-link' : ''}`}
              style={{ textDecoration: 'none', color: '#000' }}
            >
              Support
            </Nav.Link>

            <div className="position-relative" style={{ cursor: 'pointer' }} ref={profileRef}>
            <Image
              src={storedImage ? storedImage : "/assets/images/blank.jpg"}
              alt="Profile"
              roundedCircle
              width={36}
              height={36}
              className="ms-2 cursor-pointer"
              onClick={togglePopup}
            />
            {showPopup && (
              <div
                className="position-absolute end-0 mt-2 bg-white border shadow rounded p-3"
                style={{ width: '200px', zIndex: 1000 }}
              >
                <div className="d-flex align-items-center gap-2 mb-2">
                  <i className="bi bi-person-circle text-primary fs-4"></i>
                  <span className="fw-semibold">Welcome!</span>
                </div>
                <hr className="my-2" />
                {localStorage.getItem('accessToken') ? (
                  <><div
                      onClick={() => {                        
                        setShowPopup(false);
                        navigate('/myprofile');
                      } }
                      className=" fw-semibold cursor-pointer"
                    >
                    My Profile
                    </div>
                    <hr className="my-2" />
                    <div
                      onClick={() => {
                        AuthService.logout();
                        setShowPopup(false);
                        navigate('/');
                      } }
                      className="text-danger fw-semibold cursor-pointer"
                    >
                        Sign Out
                      </div></>
                ) : (
                  <div
                    onClick={handleSignInClick}
                    className="text-primary fw-semibold cursor-pointer"
                  >
                    Sign In
                  </div>
                )}
              </div>
            )}
          </div>

          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
